import styled from 'styled-components';

export const Container = styled.div`
  background-color: rgba(252, 252, 252, 1);
  position: absolute;
  z-index: 100;
  display: flex;
  width: 320px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  padding: 24px 40px;
  gap: 24px;
  box-shadow: 0px 2px 8px 0px rgba(27, 27, 27, 0.24);
  right: 20px;
`;

export const Title = styled.h1`
  font-size: 16px;
  color: rgba(27, 27, 27, 1);
  white-space: nowrap;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;